import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { getSpecificDetails } from "../../service/ApiService";
import { TAX_LIST_DETAIL } from "../../config/ApiConstant";
import UserTaxDetail from "./User-tax-detail";
import TaxPayerSpouseDetail from "./TaxPayer-spose-detail";
import DocumentToBeSigned from "./DocumentToBeSigned";
import TaxPayerPaymentDone from "./TaxPayer-Payment-Done";
import { Badge } from "primereact/badge";
import { TabView, TabPanel } from "primereact/tabview";
import { Toast } from "primereact/toast";
import Loader from "../../components/Loader/Loader";
import { useRef } from "react";


export const TaxPayerTab = () => {
  // tax payer id
  const { id }: any = useParams();
  const employee_id = id ? atob(id) : null;

  // toast ref
  const toast = useRef<any>(null);

  // tax payer detail obj
  const [userTaxFileData, setUserTaxFileData] = useState<any>({});
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.role || "";

  useEffect(() => {
    getUserTaxFileDetail();
  }, []);

  const getUserTaxFileDetail = async () => {
    try {
      const response = await getSpecificDetails(TAX_LIST_DETAIL, employee_id);

      // Parse spouse_details safely
      let spousedetails = {};
      if (response?.spouse_details) {
        spousedetails = JSON.parse(response.spouse_details);
      }

      const data = response?.documents;
      setUserTaxFileData(response);
      setPageLoad(true);
    } catch (error: any) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: error?.response?.data?.message || 'Failed to fetch details',
      });
      setPageLoad(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <AppBreadcrumb
        currentMenu="Tax File"
        pageTitle={
          <span>
            {userTaxFileData?.dec_marrige_status === 'Married' ||
            userTaxFileData?.dec_marrige_status === 'Living common-law'
              ? 'Tax Payer & Spouse Detail'
              : 'Tax Payer Detail'}{' '}
            {userTaxFileData?.data_added_manually === true && (
              <Badge severity="success" value="Added Manually" />
            )}
          </span>
        }
        pageName={
          userTaxFileData?.dec_marrige_status === 'Married' ||
          userTaxFileData?.dec_marrige_status === 'Living common-law'
            ? 'Tax Payer & Spouse Detail'
            : 'Tax Payer Detail'
        }
        goToPage={true}
      />
      <div className="mt-3">
        <TabView>
          <TabPanel
            header={
              userTaxFileData?.dec_marrige_status === 'Married' ||
              userTaxFileData?.dec_marrige_status === 'Living common-law'
                ? 'Tax Payer & Spouse Details'
                : 'Tax Payer Details'
            }
          >
            <div className="flex flex-column gap-4 pt-2">
              <div className="flex gap-2 w-full">
                {/* tax payer detail */}
                <div className={(userTaxFileData?.dec_marrige_status === "Married" || userTaxFileData?.dec_marrige_status === "Living common-law") ? "w-6" : "w-full"}>
                  <UserTaxDetail data={userTaxFileData} loading={pageLoad} refreshData={getUserTaxFileDetail} />
                </div>

                {/* tax payer spouse tab */}
                {(userTaxFileData?.dec_marrige_status === "Married" || userTaxFileData?.dec_marrige_status === "Living common-law") && (
                  <div className="w-6">
                    <TaxPayerSpouseDetail data={userTaxFileData} loading={pageLoad} refreshData={getUserTaxFileDetail} />
                  </div>
                )}
              </div>
            </div>
          </TabPanel>

          <TabPanel header="Signed Documents">
            <div className="pt-2 w-full">
              <DocumentToBeSigned data={userTaxFileData} loading={pageLoad} refreshData={getUserTaxFileDetail} />
            </div>
          </TabPanel>

          <TabPanel header="Payment">
            <div className="pt-2 w-full">
              <TaxPayerPaymentDone data={userTaxFileData} loading={pageLoad} refreshData={getUserTaxFileDetail} />
            </div>
          </TabPanel>
        </TabView>
      </div>
      {!pageLoad && <Loader />}
    </>
  );
};
